import React from "react";

import { DeleteIcon, EditIcon } from "shared/ui";

import { TableDto } from "services/tables/restModels";

import { useTablesManagementContext } from "features/TablesManagement/context";

import {
    Actions,
    CellLabel,
    CellValue,
    DescriptionCell,
    ExternalCell,
    HeaderRow,
    IconButton,
    List,
    NumberCell,
    NumberChip,
    Row,
    TitleCell,
} from "./styles";

const EMPTY_VALUE = "—";

export const TablesList = () => {
    const state = useTablesManagementContext();
    const { locale } = state;

    const localized = (values: Record<string, string>): string =>
        values[locale] || Object.values(values).find((value) => !!value) || EMPTY_VALUE;

    return (
        <List>
            <HeaderRow>
                <span>Номер</span>
                <span>Название</span>
                <span>Описание</span>
                <span>Внешний ID</span>
                <span />
            </HeaderRow>

            {state.tables.map((table: TableDto) => (
                <Row key={table.id}>
                    <NumberCell>
                        <NumberChip>{table.publicId}</NumberChip>
                    </NumberCell>

                    <TitleCell>
                        <CellLabel>Название</CellLabel>
                        <CellValue>{localized(table.title)}</CellValue>
                    </TitleCell>

                    <DescriptionCell>
                        <CellLabel>Описание</CellLabel>
                        <CellValue>{localized(table.description)}</CellValue>
                    </DescriptionCell>

                    <ExternalCell>
                        <CellLabel>Внешний ID</CellLabel>
                        <CellValue>{table.externalId || EMPTY_VALUE}</CellValue>
                    </ExternalCell>

                    <Actions>
                        <IconButton
                            type="button"
                            aria-label={`Изменить стол ${table.publicId}`}
                            onClick={() => state.openEditDialog(table)}
                        >
                            <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                            type="button"
                            $tone="danger"
                            aria-label={`Удалить стол ${table.publicId}`}
                            onClick={() => state.openDeleteDialog(table)}
                        >
                            <DeleteIcon fontSize="small" />
                        </IconButton>
                    </Actions>
                </Row>
            ))}
        </List>
    );
};
